import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import $ from "jquery";
import feather from "feather-icons";
import PerfectScrollbar from 'perfect-scrollbar';
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from '../../api/auth';
import { REGISTRY, MENU_SECTIONS } from "../../utils/resourceConfig";
import { getPermissions, hasPermission } from "utils/permission";

const Header = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth.user);
    const permissions = getPermissions(auth);
    const location = useLocation();
    const { pathname } = location;

    const onLogoutClick = (event) => {
        event.preventDefault();
        dispatch(logoutUser());
    };

    useEffect(() => {
        (function () {
            'use strict';
            feather.replace();

            const asideBody = new PerfectScrollbar('.aside-body', {
                suppressScrollX: true
            });

            if ($('.aside-backdrop').length === 0) {
                $('body').append('<div class="aside-backdrop"></div>');
            }

            var mql = window.matchMedia('(min-width:992px) and (max-width: 1199px)');

            function doMinimize(e) {
                if (e.matches) {
                    $('.aside').addClass('minimize');
                } else {
                    $('.aside').removeClass('minimize');
                }
                asideBody.update();
            }

            mql.addListener(doMinimize);
            doMinimize(mql);

            $('.aside-menu-link').on('click', function (e) {
                e.preventDefault();

                if (window.matchMedia('(min-width: 992px)').matches) {
                    $(this).closest('.aside').toggleClass('minimize');
                } else {
                    $('body').toggleClass('show-aside');
                }

                asideBody.update();
            });

            $('.nav-aside .with-sub').on('click', '.nav-link', function (e) {
                e.preventDefault();

                $(this).parent().siblings().removeClass('show');
                $(this).parent().toggleClass('show');

                asideBody.update();
            });

            $('body').on('mouseenter', '.minimize .aside-body', function () {
                $(this).parent().addClass('maximize');
            });

            $('body').on('mouseleave', '.minimize .aside-body', function () {
                $(this).parent().removeClass('maximize');
                asideBody.update();
            });

            $('body').on('click', '.aside-backdrop', function () {
                $('body').removeClass('show-aside');
            });
        })();
    }, []);

    // Active helpers
    const isExact = (path) => pathname === path;
    const isUnder = (path) => pathname === path || pathname.startsWith(path + "/");
    const anyChildActive = (children = []) => children.some(c => isUnder(c.path));

    return (
        <aside className="aside aside-fixed">
            <div className="aside-header">
                <a href="#" className="aside-logo"><img src="assets/img/name.svg" className="ht-40 img-fluid" alt="logo" /></a>
                <a href="#" className="aside-menu-link">
                    <i data-feather="menu"></i>
                    <i data-feather="x"></i>
                </a>
            </div>

            <div className="aside-body">
                <div className="aside-loggedin">
                    <div className="aside-loggedin-user">
                        <a href="#loggedinMenu" className="d-flex align-items-center justify-content-between mg-b-2" data-toggle="collapse">
                            <h6 className="tx-semibold mg-b-0">{auth.user.name}</h6>
                            <i data-feather="chevron-down"></i>
                        </a>
                        <p className="tx-color-03 tx-12 mg-b-0">{auth.user.privilege.name}</p>
                    </div>
                    <div className="collapse" id="loggedinMenu">
                        <ul className="nav nav-aside mg-b-0">
                            <li className="nav-item">
                                <Link to="#" onClick={onLogoutClick} className="nav-link">
                                    <i data-feather="log-out"></i>
                                    <span>Sign Out</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <ul className="nav nav-aside">
                    {MENU_SECTIONS.map((section, idx) => {
                        const visible = REGISTRY.filter(
                            (i) => section.match.includes(i.resource) && (i.always || hasPermission(permissions, i.resource, "read"))
                        );

                        if (!visible.length) return null;

                        return (
                            <React.Fragment key={section.label}>
                                <li className={`nav-label ${idx > 0 ? "mg-t-25" : ""}`}>{section.label}</li>

                                {visible.map((i) => {
                                    const activeGroup = (i.routes && i.routes.some((r) => isUnder(r.path))) || (i.children && anyChildActive(i.children));
                                    if (i.children?.length) {
                                        return (
                                            <li key={i.resource} className={`nav-item with-sub ${activeGroup ? 'active show' : ''}`}>
                                                <Link to="#" className="nav-link"><i data-feather={i.icon}></i> <span>{i.label}</span></Link>
                                                <ul>
                                                    {i.children.map((c) => (
                                                        <li key={c.path} className={isExact(c.path) ? 'active' : ''}>
                                                            <Link to={c.path}>{c.label}</Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        );
                                    }

                                    const first = i.routes?.[0];
                                    if (!first) return null;

                                    return (
                                        <li key={i.resource} className={`nav-item ${isUnder(first.path) ? 'active' : ''}`}>
                                            <Link to={first.path} className="nav-link">
                                                <i data-feather={i.icon}></i> <span>{i.label}</span>
                                            </Link>
                                        </li>
                                    );
                                })}
                            </React.Fragment>
                        );
                    })}
                </ul>
            </div>
        </aside>
    );
};

export default Header;
